import styled from "styled-components";
// 업무범위 카드 하나: 아이콘 + 제목 (WorkScopes가 격자로 배치)
const WorkScopeElement = ({ icon, title, details }) => {
  return (
    <Div>
      <div className="icon">{icon && <img src={icon} alt="" />}</div>
      <TitleSpan>{title}</TitleSpan>
      {details && (
        <List>
          {details.map((x) => {
            return <li key={x}>{x}</li>;
          })}
        </List>
      )}
    </Div>
  );
};
export default WorkScopeElement;
const Div = styled.div`
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.75rem 1rem 1.5rem;
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
  & > .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4.75rem;
    height: 4.75rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.accentSoft};
    & > img {
      width: 62%;
    }
  }
  &:hover {
    border-color: ${({ theme }) => theme.colors.light};
    box-shadow: ${({ theme }) => theme.shadow.md};
    transform: translateY(-3px);
  }
`;
const TitleSpan = styled.span`
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.45;
  text-align: center;
  color: ${({ theme }) => theme.colors.foreground.normal};
`;
const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
`;
